import { parsePhoneNumberFromString } from 'libphonenumber-js';

export const regexEmailValidator = (email: string) => {
    const re =
        // eslint-disable-next-line no-useless-escape
        /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
};

export const regexLinkedinURLValidator = (linkedinURL: string) => {
    const re = /^(https?:\/\/)?(www\.)?linkedin\.com\/in\/[a-zA-Z0-9_-]+\/?$/;
    return re.test(String(linkedinURL).toLowerCase());
};

export const validatePhoneNumber = (phoneNumber: string): boolean => {
    const phoneNumberData = parsePhoneNumberFromString(phoneNumber);
    return !!(phoneNumberData && phoneNumberData.isValid());
};
